import { XHRRequestCanceler } from '../../Libs/xhr/XHRRequestCanceler';
import { BaseApiDataResponse } from '../Models/ApiData';
import {
    FormationDetails,
    FormationDetailsApiDataResponse,
    FormationListOrder,
    FormationListResponse,
} from '../Models/Formation/Formation';
import { BaseDataService } from './Base/BaseDataService';

export const FormationEndpoints = {
    CREATE_FORMATION: '/api/v1/back/compagnons/formations',
    FORMATION: (formationId: string) => `/api/v1/back/compagnons/formations/${formationId}`,
    FORMATIONS: '/api/v1/back/compagnons/formations',
    EXPORT_FORMATION_LIST: '/api/v1/back/compagnons/formations/export',
};

export interface IFormationDataService {
    createFormation: (
        formation: FormationDetails,
        cts: XHRRequestCanceler
    ) => Promise<FormationDetailsApiDataResponse>;

    getFormation: (
        cts: XHRRequestCanceler,
        formationId: string
    ) => Promise<FormationDetailsApiDataResponse>;

    updateFormation: (
        formationId: string,
        formation: FormationDetails,
        cts: XHRRequestCanceler
    ) => Promise<FormationDetailsApiDataResponse>;

    deleteFormation: (formationId: string, cts: XHRRequestCanceler) => Promise<BaseApiDataResponse>;

    listFormation: (
        params: {
            search?: string;
            order?: FormationListOrder;
        },
        cts: XHRRequestCanceler
    ) => Promise<FormationListResponse>;
}

class FormationDataService extends BaseDataService implements IFormationDataService {
    public createFormation = (
        formation: FormationDetails,
        cts: XHRRequestCanceler
    ): Promise<FormationDetailsApiDataResponse> => {
        const body = {
            compagnon_id: formation.compagnon.compagnon_id,
            ...formation,
        };
        return this.post(FormationEndpoints.CREATE_FORMATION, body, cts);
    };

    public getFormation = (
        cts: XHRRequestCanceler,
        formationId: string
    ): Promise<FormationDetailsApiDataResponse> => {
        return this.get(FormationEndpoints.FORMATION(formationId), cts);
    };

    public updateFormation = (
        formationId: string,
        formation: FormationDetails,
        cts: XHRRequestCanceler
    ): Promise<FormationDetailsApiDataResponse> => {
        const body = {
            ...formation,
        };
        return this.patch(FormationEndpoints.FORMATION(formationId), body, cts);
    };

    public deleteFormation = (
        formationId: string,
        cts: XHRRequestCanceler
    ): Promise<BaseApiDataResponse> => {
        return this.delete(FormationEndpoints.FORMATION(formationId), cts);
    };

    public listFormation = (
        params: { search?: string | undefined; order?: FormationListOrder | undefined },
        cts: XHRRequestCanceler
    ): Promise<FormationListResponse> => {
        return this.get(FormationEndpoints.FORMATIONS, cts, { params });
    };
}

const FormationDataServiceName = 'FormationDataService';
export { FormationDataService, FormationDataServiceName };
